import { useState } from 'react'
import { useDebounce } from 'use-debounce'
import * as INPUTS from '../config/inputs'
import { INPUT_DEBOUNCE_RATE } from '../config/static'

export const useSlider = (slug, defaultOptions = {}) => {
  const { default: defaultValue, description, label, placeholder, step, suffix, max, min } = INPUTS[slug]
  const [value, setValue] = useState(defaultOptions.value ?? defaultValue)
  const [type, setType] = useState('')
  const [debouncedValue] = useDebounce(value, INPUT_DEBOUNCE_RATE)

  const handleChangeInput = value => {
    setValue(value)
    setType('input')
  }
  const handleChangeSlider = value => {
    setValue(value)
    setType('slider')
  }

  const props = {
    description,
    inputSliderProps: {
      label,
      sentenceFieldSimpleProps: {
        inputProps: {
          placeholder,
          step,
          type: 'number',
        },
        onChange: handleChangeInput,
        suffix,
        value,
      },
      sliderProps: {
        max,
        min,
        onChange: handleChangeSlider,
        step,
        value: value ?? 0,
      },
    },
  }

  return {
    debouncedValue,
    inputType: type,
    onChangeInput: handleChangeInput,
    props,
    value,
  }
}
